import { App } from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

export default {
  install(app: App) {
    const { warn, log } = console;

    const components = import.meta.glob('./components/**/*.vue', {
      eager: true,
    });

    Object.entries(components).forEach(([fileName, m]) => {
      if (fileName) {
        const componentName = upperFirst(
          camelCase(
            fileName
              .split('/')
              .pop()
              ?.replace(/\.\w+$/, '')
          )
        );

        if (componentName) {
          log(`Loading component ${componentName}`);
          app.component(
            componentName,
            // @ts-ignore
            m.default
          );
        } else {
          warn('Unable to load the component', {
            name: componentName,
          });
        }
      }
    });
  },
};
